import { gql } from '@/__generated__';

export const TournamentStatusFragment = gql(`
fragment TournamentStatusFragment on Tournament {
  state
  participantsCount
  deadline
}
`);
